import React from "react";
import { PageHeader } from "./PageHeader";

export default class RegistrationForm extends React.Component {

    render() {
    return (
    <React.Fragment>
      <PageHeader title="Rejestracja" />
      <div className="content-wrapper">
        <div className="main-content registration-form">
        <h2>Rejestracja uczestnikow zjazdu</h2>
            <div className="row">
                <div className="col-xs-12 col-sm-8 col-md-8">
                    <p><br/> </p>
                </div>

            </div>
            <div className="row">
                <div className="col-xs-12 col-sm-8 col-md-8">
                    <p className="alert">
                        Uprzejmie informujemy, że rejestracja na Zjazd została zakończona.
                    </p>
                </div>
                <div className="col-xs-12 col-sm-8 col-md-8 text-muted">
                    Aby zarejestrować się na "45 Zjazd Fizyków Polskich" w Krakowie, należy:
                    <ol>
                        <li>Wejść na stronę: <a href="https://reg.45zfp.if.uj.edu.pl/event/1">reg.45zfp.if.uj.edu.pl</a>. </li>
                        <li>W górnym menu po prawej stronie  wybrać język "Polski".</li>
                        <li>W górnym menu po prawej stronie  nacisnąć przycisk "Zaloguj się".</li>
                        <li>Na kolejnej stronie należy zgodnie z instrukcjami założyć nowe konto.</li>
                        <li>Po poprawnym założeniu konta oraz zalogowaniu się można przejść do zakładki "Rejestracja" oraz "Zgłaszanie abstraktów".</li>
                    </ol>
                    <p>
                        W przypadku wystąpienia pytań lub problemów z zakładaniem konta, rejestracją uczestnika lub zgłaszaniem abstraktu, uprzejmie prosimy o kontakt pod adresem email: <a href="mailto:45zfp@uj.edu.pl">45zfp@uj.edu.pl</a>.
                    </p>
                </div>
            </div>
        </div>
      </div>
    </React.Fragment>
  )};
};

RegistrationForm.propTypes = {};
